/* global axios */
import ApiClient from './ApiClient';

class MfaAPI extends ApiClient {
  constructor() {
    super('profile/mfa', { accountScoped: false });
  }

  enable(payload = {}) {
    return axios.post(`${this.url}`, payload);
  }

  updatePreferences(payload = {}) {
    return axios.patch(`${this.url}/preferences`, payload);
  }

  verify(otpCode, deliveryMethod = '') {
    return axios.post(`${this.url}/verify`, {
      otp_code: otpCode,
      delivery_method: deliveryMethod,
    });
  }

  disable(password, { otpCode, backupCode } = {}) {
    return axios.delete(this.url, {
      data: { password, otp_code: otpCode, backup_code: backupCode },
    });
  }

  regenerateBackupCodes(otpCode) {
    return axios.post(`${this.url}/backup_codes`, { otp_code: otpCode });
  }
}

export default new MfaAPI();
